import React from 'react'
import { Flex, Select, Spinner, useToast } from '@chakra-ui/react'
import { useProlongationsStore } from '../../store/prolongationsStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import ProlongationService from '../../API/ProlongationService'
import { toastError } from '../../utils/globalHelper'
import { useFetching } from '../../hooks/useFetching'

function MailingSelectTitle({prolongation, number}) {
    const toast = useToast()
    const mailingStatuses = useProlongationsStore(state => state.mailingStatuses)
    const updateProlongation = useProlongationsStore(state => state.updateProlongation)
    const updateMailingStatus = useAccessAPI(ProlongationService.updateMailingStatus)
    const updateFinalStatus = useAccessAPI(ProlongationService.updateFinalStatus)

    const initialStatusId = (
        number === 1
        ? (prolongation?.status_1?.id || 0)
        : (number === 2
            ? (prolongation?.status_2?.id || 0)
            : (number === 3
                ? (prolongation?.status_3?.id || 0)
                : (prolongation?.final_status?.id || 0)
              )
          )
    )

    const [changeStatus, isChanging] = useFetching(async (mailingStatusId) => {
        const response = number === 4
            ? await updateFinalStatus(prolongation.prolongation_id, mailingStatusId)
            : await updateMailingStatus(prolongation.prolongation_id, { status_id: mailingStatusId, number: number })
        if (response.status === 200) {
            switch (number) {
                case 1:
                    updateProlongation({
                        ...prolongation,
                        status_1: response.data.status_1,
                        date_contact_2: response.data.date_contact_2,
                    })
                    break
                case 2:
                    updateProlongation({
                        ...prolongation,
                        status_2: response.data.status_2,
                        date_contact_3: response.data.date_contact_3,
                    })
                    break
                case 3:
                    updateProlongation({
                        ...prolongation,
                        status_3: response.data.status_3,
                    })
                    break
                case 4:
                    updateProlongation({
                        ...prolongation,
                        final_status: response.data.final_status,
                    })
                    break
            }
        }
        else {
            toast(toastError('Не удалось обновить статус'))
        }
    })

    return (
        isChanging
        ?
        <Flex alignItems='center' justifyContent='center'>
            <Spinner size='sm'/>
        </Flex>
        :
        <Select
            disabled={!prolongation?.checkbox}
            size='sm'
            minW='200px'
            placeholder='-'
            value={initialStatusId}
            onChange={(e) => changeStatus(Number(e.target.value))}
        >
            {mailingStatuses.map((status) => (
                <option
                    value={status.id}
                    key={`mailing-status-${status.id}-${number}`}
                >
                    {status.title}
                </option>
            ))}
        </Select>
    )
}

export default MailingSelectTitle
